export default __webpack_public_path__ + "static/media/DnDcartoonbook2.e7e15db9.jpg";